<template>
  <div class="insights-navigation-list-card-skeleton-loading">
    <div class="body">
      <div class="skeleton-item skeleton-item-rounded"></div>
      <div class="skeleton-item skeleton-item-pill"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InsightsNavigationListCardLoading',
};
</script>
